export class TripStats {
  public constructor(
    public mileage: number[],
    public stops: number[],
    public engine: number[],
    public trip_time: number[],
    public speed_avg: number[],
    public uid_device: number[],
    public registration: string[],
    public uid_service: number[],
    public label: string[],
    public time_unit: string,
    public time_value: string[],
    public year: number[],
    public eco_avg: number[],
    public fuel_quantity_100_km: number[],
    public fuel_cost_100_km: number[],
    public CO2_100_km: number[],
    public fuel_consumed: number[],
    // Actually holds the full compare-period result (tripstats + servicedata), not just
    // the TripStats half - matches how chart.component.ts reads/writes it.
    public data_compare: TripstatsData,
    public timestamp: number
  ) {}
}

export class TripstatsData {
  tripstats: TripStats;
  servicedata: ServiceData;
}

// Cache of trip stats per dashboard widget index.
export type TripstatsRecord = Record<number, TripstatsData>;

export const fuelstats = ['fuel_quantity_100_km', 'fuel_cost_100_km', 'CO2_100_km'];

interface ServiceDataEntry {
  mileageTotal: number;
  stopsTotal: number;
  engineTotal: number;
  trip_timeTotal: number;
  speed_avgTotal: number;
  speed_avgAverage: number;
  eco_avgTotal: number;
  eco_avgAverage: number;
  fuel_quantity_100_kmTotal: number;
  fuel_cost_100_kmTotal: number;
  CO2_100_kmTotal: number;
  fuel_consumedTotal: number;
  mileage?: number[];
  stops?: number[];
  engine?: number[];
  trip_time?: number[];
  speed_avg?: number[];
  uid_service?: number[];
  label?: string[];
  eco_avg?: number[];
  fuel_quantity_100_km?: number[];
  fuel_cost_100_km?: number[];
  CO2_100_km?: number[];
  fuel_consumed?: number[];
}

export type ServiceData = Record<number, ServiceDataEntry>;
